import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { UserProvider } from "./contexts/UserContext";
import { ProviderProductsProvider } from "./contexts/ProviderProductsContext";
import { ProviderSalesProvider } from "./contexts/ProviderSalesContext";
import { TagsProvider } from "./contexts/TagsContext";
import { GoogleOAuthProvider } from '@react-oauth/google';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const AppTree = (
  <UserProvider>
    <TagsProvider>
      <ProviderProductsProvider>
        <ProviderSalesProvider>
          <App />
        </ProviderSalesProvider>
      </ProviderProductsProvider>
    </TagsProvider>
  </UserProvider>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  googleClientId ? (
    <GoogleOAuthProvider clientId={googleClientId}>
      {AppTree}
    </GoogleOAuthProvider>
  ) : (
    AppTree
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

serviceWorkerRegistration.register();
